import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=8721512a&scoped=true&"
import script from "./MessagesView.vue?vue&type=script&lang=ts&"
export * from "./MessagesView.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesView.vue?vue&type=style&index=0&id=8721512a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8721512a",
  null
  
)

export default component.exports